import { DogaNumber, DogaUrl, DogaDate } from '@/Domain/Procedures/Doga'

export class DogaInfo {
  private _publishDate: DogaDate
  private _dogaNumber: DogaNumber
  private _dogaUrl: DogaUrl

  constructor (
    publishDate: DogaDate,
    dogaNumber: DogaNumber,
    dogaUrl: DogaUrl
  ) {
    this._publishDate = publishDate
    this._dogaNumber = dogaNumber
    this._dogaUrl = dogaUrl
  }

  publishDate (): string {
    return this._publishDate.date()
  }

  dogaNumber (): number {
    return this._dogaNumber.dogaNumber()
  }

  dogaUrl (): string {
    return this._dogaUrl.url()
  }
}
